/**
 * @generated SignedSource<<80d22763cc4c2d5cbc5fb38315af6d80>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
export type JiraIssueLinkDirection = "INWARD" | "OUTWARD" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type linkRelationshipType_nativeIssueTable_LinkRelationshipTypeCell$data = {
  readonly fieldId: string;
  readonly id: string;
  readonly isEditableInIssueView?: boolean | null | undefined;
  readonly issueLink: {
    readonly direction: JiraIssueLinkDirection | null | undefined;
    readonly id: string | null | undefined;
    readonly relationName: string | null | undefined;
    readonly type: {
      readonly id: string;
    } | null | undefined;
  } | null | undefined;
  readonly name: string;
  readonly type: string;
  readonly " $fragmentSpreads": FragmentRefs<"readView_nativeIssueTable_LinkRelationshipTypeReadView">;
  readonly " $fragmentType": "linkRelationshipType_nativeIssueTable_LinkRelationshipTypeCell";
};
export type linkRelationshipType_nativeIssueTable_LinkRelationshipTypeCell$key = {
  readonly " $data"?: linkRelationshipType_nativeIssueTable_LinkRelationshipTypeCell$data;
  readonly " $fragmentSpreads": FragmentRefs<"linkRelationshipType_nativeIssueTable_LinkRelationshipTypeCell">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "name": "id"
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isInlineEditingEnabled"
    }
  ],
  "kind": "Fragment",
  "name": "linkRelationshipType_nativeIssueTable_LinkRelationshipTypeCell",
  "selections": [
    (v0/*: any*/),
    {
      "kind": "ScalarField",
      "name": "fieldId"
    },
    {
      "kind": "ScalarField",
      "name": "type"
    },
    {
      "kind": "ScalarField",
      "name": "name"
    },
    {
      "condition": "isInlineEditingEnabled",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "isEditableInIssueView"
        }
      ]
    },
    {
      "concreteType": "JiraIssueLink",
      "kind": "LinkedField",
      "name": "issueLink",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "kind": "ScalarField",
          "name": "direction"
        },
        {
          "kind": "ScalarField",
          "name": "relationName"
        },
        {
          "concreteType": "JiraIssueLinkType",
          "kind": "LinkedField",
          "name": "type",
          "plural": false,
          "selections": [
            (v0/*: any*/)
          ]
        }
      ]
    },
    {
      "kind": "FragmentSpread",
      "name": "readView_nativeIssueTable_LinkRelationshipTypeReadView"
    }
  ],
  "type": "JiraIssueLinkRelationshipTypeField"
};
})();

(node as any).hash = "f1053025018dbd5db778da2df1d588e8";

export default node;
